import React, { useEffect } from 'react';
import { Cookie } from 'lucide-react';
import Navbar from './Navbar';
import SiteFooter from './SiteFooter';

const SECTIONS = [
  {
    title: '1. What Are Cookies',
    body: 'Cookies are small text files stored on your device when you visit a website. They help the site function properly, remember your preferences, and provide information to the site owner about how the site is used.',
  },
  {
    title: '2. How We Use Cookies',
    body: 'Electronico Holdings (Pty) Ltd uses cookies to enhance your browsing experience, remember your consent preferences, keep the site secure, and understand how visitors interact with our content so we can improve it.',
  },
  {
    title: '3. Types of Cookies We Use',
    body: 'Essential cookies are required for the website to function and cannot be switched off. Preference cookies remember choices such as your cookie consent. Analytics cookies help us measure and improve site performance by collecting anonymous usage data.',
  },
  {
    title: '4. Managing Cookies',
    body: 'You can accept or decline non-essential cookies using the banner shown on your first visit. You can also control and delete cookies through your browser settings at any time. Please note that disabling certain cookies may affect the functionality of the website.',
  },
  {
    title: '5. Third-Party Cookies',
    body: 'Some cookies may be set by third-party services that appear on our pages (for example, embedded maps or analytics providers). We do not control these cookies, and you should review the relevant third party’s privacy and cookie policies.',
  },
  {
    title: '6. Your Consent (POPIA)',
    body: 'In line with the Protection of Personal Information Act (POPIA), we obtain your consent before placing non-essential cookies. Your consent choice is stored locally on your device. You may change your choice at any time by clearing your browser data.',
  },
  {
    title: '7. Contact Us',
    body: 'For any questions about this Cookie Policy, please contact us at info@electronico.co.za or +27 21 020 1435, Hermanus, Western Cape, South Africa.',
  },
];

export default function CookiePolicyPage() {
  useEffect(() => {
    document.title = 'Cookie Policy \u2014 Electronico Holdings';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative min-h-screen bg-[#0a1526] text-white" data-testid="cookie-policy-page">
      <Navbar />
      <main>
        <section className="relative pt-40 pb-16 px-5 grid-bg overflow-hidden">
          <div className="blob bg-[#0ef3fe] w-[360px] h-[360px] -top-20 -left-20 opacity-40" />
          <div className="blob bg-[#088ffe] w-[320px] h-[320px] top-10 right-0 opacity-40" />
          <div className="relative z-10 max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 rounded-full neon-border px-4 py-1.5 mb-6">
              <Cookie className="h-4 w-4 text-[#0ef3fe]" />
              <span className="font-mono-accent text-xs text-white/80">// LEGAL</span>
            </div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold">
              Cookie <span className="gradient-text">Policy</span>
            </h1>
            <p className="text-white/55 mt-5 max-w-2xl mx-auto leading-relaxed">
              How and why Electronico Holdings uses cookies on this website.
            </p>
          </div>
        </section>

        <section className="relative pb-24 px-5">
          <div className="max-w-3xl mx-auto space-y-8">
            {SECTIONS.map((s) => (
              <div key={s.title} className="neon-border rounded-2xl p-7" data-testid={`cookie-section-${s.title.split('.')[0]}`}>
                <h2 className="font-display text-xl font-bold mb-3 text-white">{s.title}</h2>
                <p className="text-sm text-white/60 leading-relaxed">{s.body}</p>
              </div>
            ))}
            <p className="text-xs text-white/35 pt-4">Last updated: {new Date().toLocaleDateString('en-ZA', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
